/**
 * IAM sample app — BROKER MODE (P3 #23). The OIDC library points at the IAM
 * broker (discovery at iamBaseUrl); no Authentik client config needed.
 *
 * Default target = UAT (`security-uat.svayamtech.com`, broker ON). The former
 * `staging-security` env is RETIRED (replaced by UAT). `ng build --configuration
 * production` swaps in environment.prod.ts (prod `security.svayamtech.com`).
 */
export const environment = {
  iamBaseUrl: 'https://security-uat.svayamtech.com',
  // OIDC client registration (iam_oidc_client seed): client_id 'iam-sample-app',
  // redirect http://localhost:4201/auth/callback.
  clientId: 'iam-sample-app',
  // Resource-server audience of the sample-app product.
  audience: 'iam-sample-app',
  // UAT org tenant a lab signup attaches to (the account subscribed to the
  // sample-app product in UAT). Account 2000 does not exist in UAT.
  labAccountId: 1000,
  // UAT (test data) may render the decoded svayam_jwt. PROD sets this false
  // (ADR: no raw-token dump) — the protected page shows only /me there.
  showRawToken: true,
};
